import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { UploaderControls, UploadResultType } from '#src/app/shared/hooks/uppyUploader';

export type ImageData = NonNullable<NonNullable<UploadResultType>['successful']>[number];

// eslint-disable-next-line complexity
export async function uploadImage(
	uploader: UploaderControls,
	image: string,
	utilityContext: UtilityContext,
): Promise<ImageData> {
	try {
		if (!image) throw new Error('No image URL provided');

		// Check if there are already files before adding a new one
		if (uploader.getFile() === undefined) {
			await uploader.addFileAsync(image);
		}

		uploader.onFileAdded(() => {});
		uploader.onUseAwsS3(utilityContext, 'USER_UPLOADS');

		const result = await uploader.upload();

		if ((result?.failed?.length ?? 0) > 0) {
			throw new Error(result?.failed?.[0]?.error ?? 'Upload failed');
		}

		if (!result?.successful?.[0]?.uploadURL) {
			throw new Error('Bad URL returned from upload');
		}

		return result.successful[0];
	} catch (e: unknown) {
		const message = e instanceof Error ? e.message : 'Unexpected error';
		const error = new Error(message, { cause: e });
		void utilityContext.errorReporter.report({ error, context: { feature: 'petition_creation' } });
		throw error;
	}
}
